import { useEffect, useMemo, useState } from "react"
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import "../styles/CampusPartner.css";

const CampusPage = () => {
    const navigate = useNavigate();

    const handleButtonClick = () => {
        navigate("/partner-brochure-amity");
    };

    const LAUNCH_DATE = new Date("2025-10-01T00:00:00+05:30");

    function useCountdown(targetDate) {
        const target = useMemo(() => targetDate.getTime(), [targetDate])
        const calc = () => {
            const now = Date.now()
            const diff = Math.max(target - now, 0)
            const days = Math.floor(diff / (1000 * 60 * 60 * 24))
            const hours = Math.floor((diff / (1000 * 60 * 60)) % 24)
            const minutes = Math.floor((diff / (1000 * 60)) % 60)
            const seconds = Math.floor((diff / 1000) % 60)
            return { diff, days, hours, minutes, seconds }
        }

        const [time, setTime] = useState(calc())

        useEffect(() => {
            const id = setInterval(() => setTime(calc()), 1000)
            return () => clearInterval(id)
        }, [target])

        return time
    }

    function CountdownTimer({ date }) {
        const { diff, days, hours, minutes, seconds } = useCountdown(date)

        if (diff <= 0) {
            return (
                <div className="countdown" role="status" aria-live="polite">
                    <div className="countdown-box">
                        <div className="countdown-ended">We’re launching now 🎉</div>
                    </div>
                </div>
            )
        }

        return (
            <div className="countdown" role="status" aria-live="polite" aria-label="Countdown to launch">
                <div className="countdown-heading">Registrations Ending In</div>
                <div className="countdown-box">
                    <div className="countdown-grid">
                        <div className="countdown-segment" aria-label={`${days} days`}>
                            <div className="countdown-value">{String(days)}</div>
                            <div className="countdown-label">days</div>
                        </div>
                        <div className="countdown-separator" aria-hidden="true">
                            :
                        </div>
                        <div className="countdown-segment" aria-label={`${hours} hours`}>
                            <div className="countdown-value">{String(hours).padStart(2, "0")}</div>
                            <div className="countdown-label">hours</div>
                        </div>
                        <div className="countdown-separator" aria-hidden="true">
                            :
                        </div>
                        <div className="countdown-segment" aria-label={`${minutes} minutes`}>
                            <div className="countdown-value">{String(minutes).padStart(2, "0")}</div>
                            <div className="countdown-label">mins</div>
                        </div>
                        <div className="countdown-separator" aria-hidden="true">
                            :
                        </div>
                        <div className="countdown-segment" aria-label={`${seconds} seconds`}>
                            <div className="countdown-value">{String(seconds).padStart(2, "0")}</div>
                            <div className="countdown-label">secs</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="campus-container">
            <div className="content">
                <h1>Bring Blox to Your Campus</h1>
                <p>Be the Reason Your Campus Gets the Blox Buzz 🤙</p>

                <CountdownTimer date={LAUNCH_DATE} />

                <button
                    className="launch-button"
                    onClick={handleButtonClick}
                    onMouseDown={(e) => {
                        e.target.style.transform = "translateY(2px)";
                        e.target.style.boxShadow = "0 2px #000";
                    }}
                    onMouseUp={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "0 4px #000";
                    }}
                >
                    help us launch
                </button>
            </div>
            <div className="image-container">
                <img
                    src="/thumbsUp.png"
                    alt="Background Stars"
                    className="background-stars"
                />
                <img src="/zigzag.png" alt="Zigzag" className="zigzag" />
                <img src="/circle.png" alt="Circle" className="circle" />
                <img
                    src="/campusHero.png"
                    alt="Campus Characters"
                    className="campusHero"
                />
            </div>
            <Footer />
        </div>
    );
};

export default CampusPage;